const swiperContainer = document.querySelector('.rlt-post-swiper');

if (
	swiperContainer &&
	swiperContainer.querySelectorAll('.swiper-slide').length > 0
) {
	const swiper = new Swiper('.rlt-post-swiper', {
		slidesPerView: 1,
		spaceBetween: 16,
		watchSlidesProgress: true,
		loop: true,
		breakpoints: {
			768: {
				slidesPerView: 2,
				spaceBetween: 20,
			},
			992: {
				slidesPerView: 3,
				spaceBetween: 20,
			},
		},
		navigation: {
			nextEl: '.rlt-post-swiper-button-next',
			prevEl: '.rlt-post-swiper-button-prev',
		},
		pagination: {
			el: '.rlt-post-swiper-pagination',
			clickable: true,
		},
	});
}
